@if (loading()) {
  <mw-app-splash />
} @else {
  <router-outlet />
}
